
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-profile/[id]",
      function () {
        return require("private-next-pages/company-profile/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company-profile/[id]"])
      });
    }
  